<div class="flex-fill d-flex flex-column">
    <div class="column ms-2 me-3"><span class="color-legend with-border acknowledged"></span> - Acknowledged</div>
    <div *ngIf="reviews" class="m-1 grid-fill" style="max-width: 100%">
        <dx-data-grid
            #dataGrid
            [dataSource]="reviews"
            keyExpr="id"
            [columnAutoWidth]="false"
            [wordWrapEnabled]="true"
            (onToolbarPreparing)="onToolbarPreparing($event)"
            (onExporting)="onExporting($event)"
            (onRowPrepared)="rowPrepare($event)"
        >
            <dxi-column dataField="id" width="80"></dxi-column>
            <dxi-column dataField="created" width="80" [sortIndex]="0" sortOrder="desc" ></dxi-column>
            <dxi-column dataField="isDealer" caption="Dealer" width="80"></dxi-column>
            <dxi-column dataField="isBoatOwner" caption="Boat Owner" width="80"></dxi-column>
            <dxi-column dataField="businessName" width="200"></dxi-column>
            <dxi-column dataField="firstName" width="200"></dxi-column>
            <dxi-column dataField="lastName" width="200"></dxi-column>
            <dxi-column dataField="email" width="200"></dxi-column>
            <dxi-column dataField="address" width="200"></dxi-column>
            <dxi-column dataField="phone" width="200"></dxi-column>
            <dxi-column dataField="productOrService" width="200"></dxi-column>
            <dxi-column dataField="overallSatisfaction" width="200"></dxi-column>
            <dxi-column dataField="productPerformance" width="200"></dxi-column>
            <dxi-column dataField="additionalComments" width="200"></dxi-column>
            <dxi-column dataField="rawData" width="1500"></dxi-column>

            <dxo-search-panel class="d-none d-sm-block" [visible]="true"></dxo-search-panel>
            <dxo-export [enabled]="true" [allowExportSelectedData]="true"></dxo-export>
            <dxo-filter-row [visible]="true"></dxo-filter-row>
            <dxo-state-storing [enabled]="true" type="localStorage" storageKey="customer-reviews-grid"></dxo-state-storing>
            <div *dxTemplate="let data of 'toolbarButtons'">
                <button
                    class="btn btn-success ms-2"
                    (click)="acknowledgeReview(dataGrid.instance.getSelectedRowsData()[0])"
                    [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1"
                >
                    Acknowledge
                </button>
                <button class="btn btn-danger ms-2" (click)="delete(dataGrid.instance.getSelectedRowsData()[0])" [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1">
                    Delete
                </button>
                <button class="btn btn-sm btn-secondary ms-4" (click)="process(dataGrid.instance.getSelectedRowsData()[0])" [disabled]="dataGrid.instance.getSelectedRowsData().length !== 1">
                    Process
                </button>
            </div>
            <div *dxTemplate="let data of 'toolbarText'">
                <span *ngIf="reviews" class="me-3"
                    ><strong>{{ dataGrid.instance.totalCount() + ' items' }}</strong></span
                >
            </div>
        </dx-data-grid>
    </div>
</div>
